import type { UseFormReturn } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import { FieldGroup, Input, Text, TextField } from '@launchpad-ui/components';

import { MetricUrls } from './components/MetricUrls';
import { RequiredLabel } from './components/RequiredLabel';
import type { MetricForm } from './formUtils';
import { MetricDefinitionFormField } from './MetricDefinitionFormField';

import styles from './CreateMetricModal.module.css';
interface ClickMetricDetailsProps {
  context: UseFormReturn<MetricForm>;
}

export const ClickMetricDetails: React.FC<ClickMetricDetailsProps> = ({ context }) => {
  const {
    control,
    register,
    formState: { errors },
  } = context;

  const selector = useWatch({ control, name: 'selector', exact: true });
  return (
    <>
      <FieldGroup errorMessage={errors.selector?.message} className={styles.labelInputWrapper}>
        <TextField className={styles.textInput}>
          <RequiredLabel label="Click target(s)" htmlFor="selector" />
          <Input
            {...register('selector', { required: 'Click target(s) are required' })}
            placeholder="Enter one or more CSS selectors"
            value={selector}
          />
        </TextField>
        <Text slot="subtitle" className={styles.kindHint}>
          Enter one or more comma-separated CSS selectors to record clicks
        </Text>
      </FieldGroup>
      <MetricUrls context={context} />
      <MetricDefinitionFormField context={context} />
    </>
  );
};
